import { render, staticRenderFns } from "./WGPageControls.vue?vue&type=template&id=08f39b69&scoped=true"
import script from "./WGPageControls.vue?vue&type=script&lang=js"
export * from "./WGPageControls.vue?vue&type=script&lang=js"
import style0 from "./WGPageControls.vue?vue&type=style&index=0&id=08f39b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../calendar/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f39b69",
  null
  
)

export default component.exports